import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  split,
} from "@apollo/client";
import { SubscriptionClient } from "subscriptions-transport-ws";
// @ts-ignore
import apolloLogger from "apollo-link-logger";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import {
  DEFCON9,
  DEFCON7,
  DEFCON5,
  DEFCON4,
  DEFCON3,
  DEFCON2,
  DEFCON1,
} from "./debug.json";

const fallbackUri = "https://titania-poll-engine.deeptracker.io/graphql";
const fallbackUriWs = "wss://wss-titania-poll-engine.deeptracker.io/graphql";

DEFCON5 &&console.log("Env. stuff");
DEFCON5 &&console.log(process.env);
DEFCON5 &&console.log(process.env.REACT_APP_GRAPHQL_ENDPOINT);
DEFCON5 &&console.log(process.env.REACT_APP_GRAPHQL_WS_ENDPOINT);
DEFCON5 &&console.log(fallbackUri);
DEFCON5 &&console.log(fallbackUriWs);

const httpLink: ApolloLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT
    ? process.env.REACT_APP_GRAPHQL_ENDPOINT
    : fallbackUri,
});

const tmplink: string =
  process.env.REACT_APP_GRAPHQL_WS_ENDPOINT || fallbackUriWs;

const subClient = new SubscriptionClient(tmplink, {
  reconnect: true,
});

const wsLink = new WebSocketLink(subClient);

const link: ApolloLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

const client = new ApolloClient({
  link: ApolloLink.from([
    apolloLogger,
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.error(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          )
        );
      if (networkError) console.error(`[Network error]: ${networkError}`);
    }),
    link,
  ]),
  cache: new InMemoryCache(),
});

export default client;
